import { TraitsGrid } from "./TraitsGrid";

export default TraitsGrid;
